import resetFormTemplate from "./resetForm.html";

export function ResetFormAppRoutesProvider(AppRoutesProvider, Routes) {
  var resolve = {
    token: function ($route) {
      return $route.current.params.token;
    }
  };

  Object.assign(this, AppRoutesProvider, {
    reset: {
      name: Routes.reset,
      resolve: resolve,
      template: '<reset-form token="$resolve.token">'
    }
  });
}

ResetFormAppRoutesProvider.$inject = ['AppRoutesProvider', 'Routes'];

export const restFormComponent = {
  template: resetFormTemplate,
  controller: resetFormController,
  bindings: { token: '<' }
};

/*******************************************************************************
 * Controller
 *******************************************************************************/
function resetFormController($injector, $scope) {
  var $svcs = { $ctrl: this, $globals: {}, $injector, $scope };

  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
}

resetFormController.$inject = ['$injector', '$scope'];

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the Controller object.
 *******************************************************************************/
function initCtrl($ctrl, $injector, $svcs) {
  Object.assign($ctrl, {
    errorMessage: null,
    password: null,
    passwordConfirm: null,
    passValidator: {},

    reset: $injector.invoke(reset, null, $svcs)
  });

  Object.defineProperty($ctrl, 'showError', {
    get: function () {
      return !!$ctrl.errorMessage;
    }
  });
}

initCtrl.$inject = ['$ctrl', '$injector', '$svcs'];

/*******************************************************************************
 * Controller.reset */
/**
 * Confirms the passwords math, and sends the new password to the server, with
 * the reset token to update the user record.
 *******************************************************************************/
function reset(
  $ctrl,
  $location,
  Alert,
  BusyScreen,
  SystemLoginServices
) {
  return function () {
    $ctrl.errorMessage = null;

    /*------------------------------*/
    /* Confirm the passwords match. */
    /*------------------------------*/
    if ($ctrl.password !== $ctrl.passwordConfirm) {
      $ctrl.errorMessage = 'Passwords must match.';
      return;
    }

    BusyScreen.setBusy(true);
    SystemLoginServices.reset($ctrl.token, $ctrl.password).then(
      function () {
        BusyScreen.setBusy(false);
        Alert.show(
          'Your password has been updated. You may now login with your new password.'
        ).then(function () {
          $location.path('/');
        });
      },
      function (resp) {
        BusyScreen.setBusy(false);
        Alert.error(resp.parsedResponse.message(), 'Reset Failed');
      }
    );
  };
}

reset.$inject = [
  '$ctrl',
  '$location',
  'Alert',
  'BusyScreen',
  'SystemLoginServices'
];
